import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomerTestimonialCard from './AgentTestimonialCard';
import '../App.css';
import VimeoVideoEmbed from './youtubeVideoEmbed';

export default class PreviousNextMethods extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <div style={{ backgroundColor: '#BCD400'}}>
        <div className='auto-scale-text-lg color-white' style={{ textAlign: 'center', width: '100%', paddingTop: '5rem', marginBottom: '2rem' }}>AGENT STORIES</div>
        <Slider ref={c => (this.slider = c)} {...settings}>
          <div key={1}>
          <div className="video-responsive">
            <iframe 
                title='vimeo video'
                src={`https://player.vimeo.com/video/874952327?color=BCD400&title=0&byline=0&portrait=0`}
                width="640" 
                height="360" 
                frameborder="0" 
                allow="autoplay; fullscreen" 
                allowfullscreen>
            </iframe>
        </div>
          </div>
          <div key={3}>
          <div className="video-responsive">
            <iframe 
                title='vimeo video'
                src={`https://player.vimeo.com/video/874954769?color=BCD400&title=0&byline=0&portrait=0`}
                width="640" 
                height="360" 
                frameborder="0" 
                allow="autoplay; fullscreen" 
                allowfullscreen>
            </iframe>
        </div>
          </div>
          <div key={4}>
          <div className="video-responsive">
            <iframe 
                title='vimeo video'
                src={`https://player.vimeo.com/video/874954274?color=BCD400&title=0&byline=0&portrait=0`}
                width="640" 
                height="360" 
                frameborder="0" 
                allow="autoplay; fullscreen" 
                allowfullscreen>
            </iframe>
        </div>
          </div>
          <div key={5}>
          <div className="video-responsive" >
            <iframe 
                title='vimeo video'
                src={`https://player.vimeo.com/video/874955675?color=BCD400&title=0&byline=0&portrait=0`}
                width="640" 
                height="360" 
                frameborder="0" 
                allow="autoplay; fullscreen" 
                allowfullscreen>
            </iframe>
        </div>
          </div>
          <div key={6}>
          <div className="video-responsive" >
            <iframe 
                title='vimeo video'
                src={`https://player.vimeo.com/video/875048099?color=BCD400&title=0&byline=0&portrait=0`}
                width="640" 
                height="360" 
                frameborder="0" 
                allow="autoplay; fullscreen" 
                allowfullscreen>
            </iframe>
        </div>
            </div>

        </Slider>
        <div style={{ textAlign: "center" }}> 

          <button className="dnr_button" style={{ backgroundColor:'#333', color:'white', margin:'2rem'}} onClick={this.previous}>
            Previous
          </button>
          <button className="dnr_button" style={{ backgroundColor:'#333', color:'white', margin:'2rem'}} onClick={this.next}>
            Next
          </button>
        </div>
      </div>
    );
  }
}